import { useEffect } from 'react';

/** Notifies parent when form JSON differs from the baseline snapshot (modal open / last save). */
export function useNotifyFormDirty(form, baseline, onDirtyChange) {
  useEffect(() => {
    if (!onDirtyChange) return undefined;
    onDirtyChange(JSON.stringify(form) !== JSON.stringify(baseline));
    return undefined;
  }, [form, baseline, onDirtyChange]);
}
